import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Get the base path for API calls.
 * For subdomain deployments (e.g., ai-manager.example.com), this should be empty ''.
 * For subpath deployments (e.g., example.com/ai-manager), this should be the path prefix.
 *
 * Set NEXT_PUBLIC_BASE_PATH at build time to configure:
 * - '' (empty) for subdomain deployments
 * - '/ai-manager' for subpath deployments
 */
export function getBasePath(): string {
  // Check for explicit empty string (subdomain deployment)
  // NEXT_PUBLIC_BASE_PATH='' means no base path
  const envBasePath = process.env.NEXT_PUBLIC_BASE_PATH;

  // If explicitly set (even to empty string), use it
  if (envBasePath !== undefined) {
    return envBasePath;
  }

  if (typeof window === 'undefined') {
    // Server-side: default to empty for subdomain deployment
    return '';
  }

  // Client-side: check Next.js data
  if ((window as any).__NEXT_DATA__?.basePath !== undefined) {
    return (window as any).__NEXT_DATA__.basePath;
  }

  // Default to empty (subdomain deployment)
  return '';
}

/**
 * Construct an API URL with the correct base path
 */
export function apiUrl(path: string): string {
  const basePath = getBasePath();
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  // Combine basePath and path
  return `${basePath}${cleanPath}`;
}

